import { useMemo } from 'react';

import { useUserContext } from '@context/UserContext';
import { EPage } from '@types';
import { AB_TEST_CHECKOUT_WITHOUT_UPSELLING } from '@utils/constants';

export const useAbTestCheckoutWithoutUpselling = () => {
  const {
    state: { abTests },
  } = useUserContext();

  return useMemo(() => {
    return {
      redirectPage: abTests.get(AB_TEST_CHECKOUT_WITHOUT_UPSELLING) === 2 ? EPage.CART_LOG_IN : EPage.UPSELLING,
    };
  }, [abTests]);
};
